import React, { JSX } from 'react';
import { ApiBookedItem, ApiItemType } from '@ibe/api';
import DateDisplay from '../Components/UI/DateDisplay/DateDisplay';

interface Props {
  item: ApiBookedItem;
  format?: string;
}

const Dates = (props: Props): JSX.Element => {
  const { item, format } = props;
  return (
    <>
      <DateDisplay date={item.startDate} format={format} />
      {item.endDate && (item.endDate !== item.startDate || item.itemType === ApiItemType.FLIGHT) && (
        <>
          {' - '}
          <DateDisplay date={item.endDate} format={format} />
        </>
      )}
    </>
  );
};

export default Dates;
